"use client";

import { c as _c } from "react/compiler-runtime";
import { FallbackImage } from "@/components/common/FallbackImage";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import React, { useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import useKeyPressEvent from "react-use/lib/useKeyPressEvent";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { ExpandedMediaToolbar } from "./MediaActionToolbar";
export function requestCenteredImageFullscreen(fullscreenTarget: HTMLImageElement) {
  const previousObjectPosition = fullscreenTarget.style.objectPosition;
  fullscreenTarget.style.objectPosition = "center";
  const restoreInlinePosition = () => {
    if (document.fullscreenElement === fullscreenTarget) {
      return;
    }
    fullscreenTarget.style.objectPosition = previousObjectPosition;
    document.removeEventListener("fullscreenchange", restoreInlinePosition);
  };
  document.addEventListener("fullscreenchange", restoreInlinePosition);
  fullscreenTarget.requestFullscreen().catch(() => {
    document.removeEventListener("fullscreenchange", restoreInlinePosition);
    fullscreenTarget.style.objectPosition = previousObjectPosition;
  });
}
export function ImageMediaModal(t0) {
  const $ = _c(40);
  const {
    src,
    imageRef,
    onClose,
    onOpen,
    openLabel,
    onDownload,
    isDownloading,
    onFullscreen,
    fullscreenTargetAvailable: t1,
    gallery
  } = t0;
  const fullscreenTargetAvailable = t1 === undefined ? true : t1;
  const [isZoomed, setIsZoomed] = useState(false);
  const showGalleryControls = Boolean(gallery && gallery.total > 1);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsZoomed(false);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== src) {
    t3 = [src];
    $[1] = src;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== gallery) {
    t4 = () => {
      if (gallery?.canGoPrevious) {
        gallery.onPrevious();
      }
    };
    $[3] = gallery;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const goToPrevious = t4;
  let t5;
  if ($[5] !== gallery) {
    t5 = () => {
      if (gallery?.canGoNext) {
        gallery.onNext();
      }
    };
    $[5] = gallery;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const goToNext = t5;
  useKeyPressEvent("Escape", onClose);
  useKeyPressEvent("ArrowLeft", goToPrevious);
  useKeyPressEvent("ArrowRight", goToNext);
  const isPointInsideRenderedImage = _temp;
  let t6;
  if ($[7] !== imageRef || $[8] !== onClose) {
    t6 = event => {
      event.stopPropagation();
      const image_0 = imageRef.current;
      if (!image_0 || event.detail === 0) {
        onClose();
        return;
      }
      if (!isPointInsideRenderedImage(image_0, event.clientX, event.clientY)) {
        onClose();
      }
    };
    $[7] = imageRef;
    $[8] = onClose;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const handleExpandedImageButtonClick = t6;
  let t7;
  if ($[10] !== onClose) {
    t7 = <button type="button" aria-label="Close modal" data-testid="modal-backdrop" onClick={onClose} className="tw-fixed tw-inset-0 tw-z-1000 tw-border-0 tw-bg-black/80 tw-p-0" />;
    $[10] = onClose;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      disabled: true
    };
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = !isZoomed;
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = event_3 => setIsZoomed(event_3.state.scale > 1);
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== handleExpandedImageButtonClick || $[15] !== imageRef || $[16] !== src) {
    t11 = () => <div className="tw-pointer-events-none tw-fixed tw-inset-0 tw-z-[1001] tw-flex tw-items-center tw-justify-center tw-overflow-hidden"><div className="tw-pointer-events-auto tw-relative tw-flex tw-h-[90dvh] tw-w-[95vw] tw-flex-col"><div className="tw-flex tw-min-h-0 tw-min-w-0 tw-flex-1 tw-flex-col tw-items-center tw-justify-center"><TransformComponent wrapperClass="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center" contentClass="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center" wrapperStyle={{
            width: "95vw",
            height: "90dvh"
          }} contentStyle={{
            width: "95vw",
            height: "90dvh"
          }}><button type="button" aria-label="Close modal" className="tw-relative tw-h-full tw-w-full tw-border-0 tw-bg-transparent tw-p-0" onClick={handleExpandedImageButtonClick}><FallbackImage ref={imageRef} primarySrc={src} fallbackSrc={src} alt="Full size drop media" fill={true} sizes="95vw" optimize={false} style={{
                objectFit: "contain",
                objectPosition: "center",
                pointerEvents: "auto"
              }} /></button></TransformComponent></div></div></div>;
    $[14] = handleExpandedImageButtonClick;
    $[15] = imageRef;
    $[16] = src;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== src || $[19] !== t11 || $[20] !== t9) {
    t12 = <TransformWrapper key={src} panning={t8} limitToBounds={t9} smooth={true} onZoom={t10}>{t11}</TransformWrapper>;
    $[18] = src;
    $[19] = t11;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== gallery || $[23] !== goToNext || $[24] !== goToPrevious || $[25] !== showGalleryControls) {
    t13 = showGalleryControls && gallery && <><button type="button" aria-label="Previous image" title="Previous image" disabled={!gallery.canGoPrevious} onClick={event_4 => {
        event_4.stopPropagation();
        goToPrevious();
      }} className="tw-fixed tw-left-3 tw-top-1/2 tw-z-[1101] tw-inline-flex tw-size-10 -tw-translate-y-1/2 tw-items-center tw-justify-center tw-rounded-xl tw-border-0 tw-bg-iron-900/95 tw-text-iron-100 tw-shadow-lg tw-shadow-black/30 tw-ring-1 tw-ring-inset tw-ring-iron-700/70 tw-backdrop-blur tw-transition tw-duration-200 desktop-hover:hover:tw-bg-iron-700 disabled:tw-cursor-default disabled:tw-opacity-40 sm:tw-left-4 sm:tw-size-12"><ChevronLeftIcon className="tw-size-6" aria-hidden="true" /></button><button type="button" aria-label="Next image" title="Next image" disabled={!gallery.canGoNext} onClick={event_5 => {
        event_5.stopPropagation();
        goToNext();
      }} className="tw-fixed tw-right-3 tw-top-1/2 tw-z-[1101] tw-inline-flex tw-size-10 -tw-translate-y-1/2 tw-items-center tw-justify-center tw-rounded-xl tw-border-0 tw-bg-iron-900/95 tw-text-iron-100 tw-shadow-lg tw-shadow-black/30 tw-ring-1 tw-ring-inset tw-ring-iron-700/70 tw-backdrop-blur tw-transition tw-duration-200 desktop-hover:hover:tw-bg-iron-700 disabled:tw-cursor-default disabled:tw-opacity-40 sm:tw-right-4 sm:tw-size-12"><ChevronRightIcon className="tw-size-6" aria-hidden="true" /></button><div className="tw-fixed tw-left-1/2 tw-z-[1101] -tw-translate-x-1/2 tw-rounded-lg tw-bg-iron-900/95 tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-text-iron-100 tw-shadow-lg tw-shadow-black/30 tw-ring-1 tw-ring-inset tw-ring-iron-700/70 tw-backdrop-blur" data-testid="image-gallery-counter" style={{
        bottom: "calc(env(safe-area-inset-bottom, 0px) + 1rem)"
      }}>{gallery.currentIndex + 1} / {gallery.total}</div></>;
    $[22] = gallery;
    $[23] = goToNext;
    $[24] = goToPrevious;
    $[25] = showGalleryControls;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== fullscreenTargetAvailable || $[28] !== isDownloading || $[29] !== onClose || $[30] !== onDownload || $[31] !== onFullscreen || $[32] !== onOpen || $[33] !== openLabel) {
    t14 = <ExpandedMediaToolbar onOpen={onOpen} openLabel={openLabel} onDownload={onDownload} isDownloading={isDownloading} onFullscreen={onFullscreen} fullscreenTargetAvailable={fullscreenTargetAvailable} onClose={onClose} />;
    $[27] = fullscreenTargetAvailable;
    $[28] = isDownloading;
    $[29] = onClose;
    $[30] = onDownload;
    $[31] = onFullscreen;
    $[32] = onOpen;
    $[33] = openLabel;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== t12 || $[36] !== t13 || $[37] !== t14 || $[38] !== t7) {
    t15 = createPortal(<div className="tailwind-scope tw-relative tw-z-1000 tw-cursor-default" onTouchStart={_temp2} onTouchEnd={_temp3} onTouchMove={_temp4}>{t7}{t12}{t13}{t14}</div>, document.body);
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
    $[38] = t7;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  return t15;
}
function _temp4(event_2) {
  return event_2.stopPropagation();
}
function _temp3(event_1) {
  return event_1.stopPropagation();
}
function _temp2(event_0) {
  return event_0.stopPropagation();
}
function _temp(image, clientX, clientY) {
  const rect = image.getBoundingClientRect();
  const naturalWidth = image.naturalWidth;
  const naturalHeight = image.naturalHeight;
  if (rect.width <= 0 || rect.height <= 0 || naturalWidth <= 0 || naturalHeight <= 0) {
    return true;
  }
  const imageAspectRatio = naturalWidth / naturalHeight;
  const containerAspectRatio = rect.width / rect.height;
  const renderedWidth = imageAspectRatio > containerAspectRatio ? rect.width : rect.height * imageAspectRatio;
  const renderedHeight = imageAspectRatio > containerAspectRatio ? rect.width / imageAspectRatio : rect.height;
  const renderedLeft = rect.left + (rect.width - renderedWidth) / 2;
  const renderedTop = rect.top + (rect.height - renderedHeight) / 2;
  return clientX >= renderedLeft && clientX <= renderedLeft + renderedWidth && clientY >= renderedTop && clientY <= renderedTop + renderedHeight;
}